<label class="label-form-control select-label">Select a field to format</label>
<div
  class="form-control form-control-sm select-form-control"
  [class.control-focus]="fieldsMenuTrigger.menuOpen"
  [class.disabled]="!fields.length"
  [matMenuTriggerFor]="fieldsMenu"
  #fieldsMenuTrigger="matMenuTrigger">
  <div class="display">
    {{ selectedField ? selectedField.displayName : 'Fields' }}
  </div>
  <capra-icon class="select-icon" icon="icon-caret-down"></capra-icon>
</div>
<mat-menu
  #fieldsMenu="matMenu"
  class="field-selector-select-menu">
  <button
    *ngFor="let field of fields; trackBy: fieldTrackByFn"
    mat-menu-item
    (click)="selectField(field)"
    [ngClass]="(field.variableType | lowercase)+'-field'"
    [class.ordinal-field]="field.variableLevel"
    [class.selected]="selectedField?.formatKey === field.formatKey">
    <div>
      <capra-icon
        [icon]="field.icon">
      </capra-icon>
      <span>{{field.displayName}}</span>
    </div>
    <div class="caption-text"
      *ngIf="field.captionText">
      {{ field.captionText }}
    </div>
  </button>
</mat-menu>
